/* eslint-disable @typescript-eslint/ban-types */
import { ɵNG_COMP_DEF } from '@angular/core';

export const getLifecyclePrototype = (instanceConstructor: Function) => {
    const desc = Object.getOwnPropertyDescriptor(instanceConstructor, ɵNG_COMP_DEF);
    if (!!desc && !desc.get) { // check for ivy AND aot
        // Using private API until the corresponding Angular issues are resolved.
        // Issues:  https://github.com/angular/angular/issues/31495, https://github.com/angular/angular/issues/30497
        // PR:      https://github.com/angular/angular/pull/35464
        return (instanceConstructor as any)[ɵNG_COMP_DEF];
    } else {
        return instanceConstructor.prototype;
    }
};

export const getLifecycleHook = (instanceConstructor: Function, hook: 'ngOnDestroy' | 'ngOnInit' | 'ngOnChanges') => {
    const desc = Object.getOwnPropertyDescriptor(instanceConstructor, ɵNG_COMP_DEF);
    if (!!desc && !desc.get) { // check for ivy AND aot
        // Using private API until the corresponding Angular issues are resolved.
        // Issues:  https://github.com/angular/angular/issues/31495, https://github.com/angular/angular/issues/30497
        // PR:      https://github.com/angular/angular/pull/35464
        return (instanceConstructor as any)[ɵNG_COMP_DEF]['o' + hook.slice(3)];
    } else {
        return instanceConstructor.prototype[hook];
    }
};

export const setLifecycleHook = (instanceConstructor: Function, hook: 'ngOnDestroy' | 'ngOnInit' | 'ngOnChanges', func: Function) => {
    const desc = Object.getOwnPropertyDescriptor(instanceConstructor, ɵNG_COMP_DEF);
    if (!!desc && !desc.get) { // check for ivy AND aot
        // Using private API until the corresponding Angular issues are resolved.
        // Issues:  https://github.com/angular/angular/issues/31495, https://github.com/angular/angular/issues/30497
        // PR:      https://github.com/angular/angular/pull/35464
        return (instanceConstructor as any)[ɵNG_COMP_DEF]['o' + hook.slice(3)] = func;
    } else {
        return instanceConstructor.prototype[hook] = func;
    }
};
